import React from 'react';

export default function Stairs() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2223 15.9996C30.2223 23.8543 23.8548 30.2218 16.0001 30.2218C8.14534 30.2218 1.77783 23.8543 1.77783 15.9996C1.77783 8.14485 8.14534 1.77734 16.0001 1.77734C23.8548 1.77734 30.2223 8.14485 30.2223 15.9996Z"
        fill="white"
        stroke="black"
        strokeMiterlimit="10"
      />
      <path
        d="M14.2222 14.2222L10.6667 14.2222V17.697H8L8 22.2222L22.2222 22.2222L22.2222 8H17.7778V11.2323L14.2222 11.2323V14.2222Z"
        stroke="black"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
